import { AgentScoreService } from '@modules/real-property-agent-details/modules/agent-score/services/agent-score.service';

export const services = [AgentScoreService];

export * from './agent-score.service';
